import { useEffect, useState } from "react";

import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from "antd";
import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import ProjectDatatable from "./projectdatatable";
import PageHeader from "../../admin/pageHeader/pageheader";

function Projectindex() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectdata, setselectData] = useState([]);
  const [selectClientData, setselectClientData] = useState([]);
  const [form] = Form.useForm();

  const filterProject = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),

        projectName: values.projectName,
        clientid: values.clientid,
        assignedTo: values.assignedTo,
        status: true,
      };
      const url = API.PROJECT_FILTERING;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchHrproject = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_PROJECT;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrproject(page, pageSize);
  }, [page, pageSize]);

  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.EMPLOYEE_LISTING;
      const { data }: any = await GET(url, null);
      setselectData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchEmployee();
  }, []);

  const fetchClient = async () => {
    try {
      setIsLoading(true);
      const url = API.CLIENT_LISTING;
      const { data }: any = await GET(url, null);
      setselectClientData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchClient();
  }, []);

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        projectId: values.projectId,
        projectType: values.projectType,
        projectName: values.projectName,
        startDate: values.startDate,
        endDate: values.endDate,
        clientid: Number(values.clientid),
        status: values.status,
        description: values.description,
        assignedTo: Number(values.assignedTo),
        priority: values.priority,
        hours: Number(values.hours),
        minitues: Number(values.minitues),
      };

      setIsLoading(true);
      const api = API.PROJECT_CREATE;
      const postRequest: any = await POST(api, obj);
      if (postRequest.status) {
        notification.success({ message: "Project created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  return (
    <div>
      <PageHeader>
        <Button
          type="primary"
          onClick={showModal}
          style={{ marginRight: "10px" }}
        >
          Create Project
        </Button>
      </PageHeader>
      <div>
        <Card>
          <Form form={form} onFinish={filterProject} layout="vertical">
            <Row gutter={16} align="middle">
              <Col sm={6}>
                <Form.Item name="projectName" label=" projectName">
                  <Input placeholder=" projectName" allowClear />
                </Form.Item>
              </Col>

              <Col sm={6}>
                {selectClientData && (
                  <Form.Item
                    label="Client Name"
                    name="clientid"
                    style={{ marginBottom: 10 }}
                  >
                    <Select
                      placeholder="Select an Client Name"
                      size="large"
                      allowClear
                    >
                      {selectClientData?.map((users: any, i: any) => (
                        <Select.Option
                          key={users?.id}
                          value={Number(users?.id)}
                        >
                          {users?.companyName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>
              <Col sm={6}>
                {selectdata && (
                  <Form.Item
                    label="Employee Name"
                    name="assignedTo"
                    style={{ marginBottom: 10 }}
                  >
                    <Select
                      placeholder="Select an employee"
                      size="large"
                      allowClear
                    >
                      {selectdata?.map((users: any, i: any) => (
                        <Select.Option
                          key={users?.id}
                          value={Number(users?.id)}
                        >
                          {users?.fullName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>

              <Col sm={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
        <Modal
          title="Create Project"
          visible={isModalOpen}
          onCancel={handleCancel}
          width={1000}
          footer={false}
        >
          <Form form={form} onFinish={submitHandler} layout="vertical">
            <Row gutter={16}>
              <Col sm={6}>
                <Form.Item
                  name="projectId"
                  label=" projectId"
                  rules={[{ required: true, message: "Enter projectId" }]}
                >
                  <Input placeholder=" projectId" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="projectType"
                  label="projectType"
                  rules={[{ required: true, message: "Enter projectType" }]}
                >
                  <Input placeholder="projectType" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="projectName"
                  label="projectName"
                  rules={[{ required: true, message: "Enter projectName" }]}
                >
                  <Input placeholder="projectName" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item
                  name="startDate"
                  label="startDate"
                  rules={[{ required: true, message: "Select startDate" }]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="endDate"
                  label="endDate"
                  rules={[{ required: true, message: "Select endDate" }]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="description"
                  label="description"
                  rules={[{ required: true, message: "Enter description" }]}
                >
                  <Input.TextArea placeholder="description" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item name="status" label="status">
                  <Input placeholder="status" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                {selectClientData && (
                  <Form.Item
                    label="Client Name"
                    name="clientid"
                    style={{ marginBottom: 10 }}
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Select an Client Name" size="large">
                      {selectClientData?.map((users: any, i: any) => (
                        <Select.Option
                          key={users?.id}
                          value={Number(users?.id)}
                        >
                          {users?.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>
              <Col sm={6}>
                {selectdata && (
                  <Form.Item
                    label="Employee Name"
                    name="assignedTo"
                    style={{ marginBottom: 10 }}
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Select an employee" size="large">
                      {selectdata?.map((users: any, i: any) => (
                        <Select.Option
                          key={users?.id}
                          value={Number(users?.id)}
                        >
                          {users?.fullName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>

              <Col sm={6}>
                <Form.Item name="priority" label="priority">
                  <Input placeholder="priority" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="hours" label="hours">
                  <Input placeholder="hours" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="minitues" label="minitues">
                  <Input placeholder="minitues" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Create Project
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>

      <div>
        <ProjectDatatable
          dataSource={data}
          isLoading={isLoading}
          meta={meta}
          // onPageChange={(newPage: number, newPageSize: number) => {
          //   setPage(newPage);
          //   setPageSize(newPageSize);
          // }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total_count,
            onChange: (page: any, pageSize: any) => {
              setPage(page);
              setPageSize(pageSize);
            },
          }}
        />
      </div>
    </div>
  );
}

export default Projectindex;
